<div class="app-main__inner">

  <!-- Global error (delete errors shown in list) -->
  <div class="alert alert-danger alert-dismissible d-flex align-items-center gap-2" *ngIf="view === 'list' && errorMessage">
    <i class="pe-7s-close-circle"></i><span>{{ errorMessage }}</span>
    <button type="button" class="btn-close" (click)="errorMessage = ''"></button>
  </div>

  <!-- ========== LIST VIEW ========== -->
  <div *ngIf="view === 'list'" class="bb-list-view">
    <div class="card bb-fill-card">
      <div class="card-header d-flex align-items-center justify-content-between">
        <span class="fw-semibold"><i class="pe-7s-map me-2 text-primary"></i>Routes List</span>
        <div class="d-flex align-items-center gap-2">
          <span class="badge bg-secondary">{{ records.length }} records</span>
          <button type="button" class="btn btn-primary btn-sm" (click)="addNew()">
            <i class="pe-7s-plus me-1"></i> Add New Route
          </button>
        </div>
      </div>
      <div class="card-body p-0 bb-fill-body">

        <div class="text-center py-5" *ngIf="isListLoading">
          <div class="spinner-border text-primary"></div>
          <p class="mt-2 text-muted">Loading routes...</p>
        </div>

        <vio-table-v2 *ngIf="!isListLoading" [tableData]="records" [tableConfig]="tableConfig">
        </vio-table-v2>

      </div>
    </div>
  </div>

  <!-- ========== FORM VIEW ========== -->
  <div *ngIf="view === 'form'">

    <div class="alert alert-success alert-dismissible d-flex align-items-center gap-2" *ngIf="successMessage">
      <i class="pe-7s-check"></i><span>{{ successMessage }}</span>
      <button type="button" class="btn-close" (click)="successMessage = ''"></button>
    </div>
    <div class="alert alert-danger alert-dismissible d-flex align-items-center gap-2" *ngIf="errorMessage">
      <i class="pe-7s-close-circle"></i><span>{{ errorMessage }}</span>
      <button type="button" class="btn-close" (click)="errorMessage = ''"></button>
    </div>

    <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>

      <div class="card mb-4">
        <div class="card-header fw-semibold">
          <i class="pe-7s-map me-2 text-primary"></i> Route Details
        </div>
        <div class="card-body">
          <div class="row g-3">

            <div class="col-md-3">
              <label class="form-label">Route ID <span class="text-danger">*</span></label>
              <input type="text" formControlName="routeid" class="form-control"
                     [class.is-invalid]="isFieldInvalid('routeid')"
                     placeholder="e.g. RT001" maxlength="20" />
              <div class="invalid-feedback">
                <span *ngIf="f['routeid'].errors?.['required']">Route ID is required.</span>
                <span *ngIf="f['routeid'].errors?.['maxlength']">Max 20 characters.</span>
              </div>
            </div>

            <div class="col-md-9">
              <label class="form-label">Description <span class="text-danger">*</span></label>
              <input type="text" formControlName="description" class="form-control"
                     [class.is-invalid]="isFieldInvalid('description')"
                     placeholder="e.g. North Zone Morning Delivery" maxlength="200" />
              <div class="invalid-feedback">
                <span *ngIf="f['description'].errors?.['required']">Description is required.</span>
                <span *ngIf="f['description'].errors?.['minlength']">Must be at least 3 characters.</span>
              </div>
            </div>

            <div class="col-md-4">
              <label class="form-label">Day of Run (1–31) <span class="text-danger">*</span></label>
              <input type="number" formControlName="dataofrun" class="form-control"
                     [class.is-invalid]="isFieldInvalid('dataofrun')"
                     placeholder="e.g. 15" min="1" max="31" />
              <div class="invalid-feedback">
                <span *ngIf="f['dataofrun'].errors?.['required']">Day of run is required.</span>
                <span *ngIf="f['dataofrun'].errors?.['min'] || f['dataofrun'].errors?.['max']">Must be between 1 and 31.</span>
              </div>
              <div class="form-text">The day of each month this route runs.</div>
            </div>

            <div class="col-md-5">
              <label class="form-label">Runner <span class="text-danger">*</span></label>
              <select formControlName="runnerid" class="form-select"
                      [class.is-invalid]="isFieldInvalid('runnerid')">
                <option value="">-- Select Runner --</option>
                <option *ngFor="let r of runners" [value]="r._id">{{ r.name }}</option>
              </select>
              <div class="invalid-feedback">Runner is required.</div>
              <div class="form-text" *ngIf="runners.length === 0">
                No runners available. Add a user with User Type = Runner first.
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="d-flex gap-2 mb-4">
        <button type="button" class="btn btn-outline-secondary" (click)="backToList()">
          <i class="pe-7s-close me-1"></i> Cancel
        </button>
        <button type="submit" class="btn btn-primary" [disabled]="isSaving">
          <span *ngIf="!isSaving">
            <i class="pe-7s-diskette me-1"></i>
            {{ isEditMode ? 'Update Route' : 'Save Route' }}
          </span>
          <span *ngIf="isSaving" class="d-flex align-items-center gap-2">
            <span class="spinner-border spinner-border-sm"></span> Saving...
          </span>
        </button>
      </div>

    </form>
  </div>

</div>
